export default __webpack_public_path__ + "static/tip5-e70d0260a8d18486367fc0ec5e2905df.png";